// PayIntern.js
import React, { useState } from "react";
import axios from "axios";
import "../styles/PayIntern.css";
import { useLocation } from "react-router-dom";
const PayIntern = () => {

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const collegeFromUrl = params.get("college");
  const [formData, setFormData] = useState({
    internName: "",
    email: "",
    mobile: "",
    collegeName: collegeFromUrl || "",
    branch: "",
    course: "",
    amount: ""
  });
  const [acceptedTerms, setAcceptedTerms] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    // When course changes
    if (name === "course") {

      let calculatedAmount = 0;

      if (value === "Machine Learning") {
        calculatedAmount = 2500;
      }
      else if (value === "Deep Learning") {
        calculatedAmount = 3500;
      }
      else if (value === "Quantum Computing") {
        calculatedAmount = 4500;
      }

      setFormData((prev) => ({
        ...prev,
        course: value,
        amount: calculatedAmount
      }));

    }

    // When promo code changes

    // Other fields
    else {
      setFormData((prev) => ({
        ...prev,
        [name]: value
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!acceptedTerms) {
      alert("Please accept Terms & Conditions to proceed.");
      return;
    }
    if (!formData.internName || !formData.course) {
      alert("Please fill all required fields");
      return;
    }
    setIsLoading(true);

    try {
      const orderId = "INT-" + Math.floor(Math.random() * 1000000);

      const response = await axios.post("/api/payment/create-session", {
        name: formData.internName,
        email: formData.email,
        mobile: formData.mobile,
        orderId,
        type: "internship",
        collegeName: formData.collegeName,
        branch: formData.branch,
        course: formData.course
      });

      const { payment_links } = response.data;

      if (payment_links?.web) {
        window.location.href = payment_links.web;
      } else {
        alert("Payment failed: No payment link returned");
      }
    } catch (err) {
      console.error(err);
      alert("Something went wrong. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="payintern-wrapper">
      <div className="payintern-card">
        <div className="payintern-header">
          <div className="header-left">
            <img
              src="/images/cvey-logo.jpg"
              alt="CVEY Logo"
              className="cvey-logo"
            />
            <span className="cvey-text">CVEY Solutions</span>
          </div>

          <h2 className="payintern-title">Intern Enrollment</h2>

          <div className="header-right">
            <img
              src="/images/msme.png"
              alt="MSME Logo"
              className="msme-logo"
            />
          </div>

        </div>

        <form className="payintern-form" onSubmit={handleSubmit}>

          <input
            name="internName"
            placeholder="Intern Name"
            value={formData.internName}
            onChange={handleChange}
            required
          />

          {/* <input
            name="collegeName"
            placeholder="College Name"
            value={formData.collegeName}
            onChange={handleChange}
            required
            readOnly={collegeFromUrl}
          /> */}
          <input
            type="hidden"
            name="collegeName"
            value={formData.collegeName}
          />
          <input
            name="branch"
            placeholder="Branch"
            value={formData.branch}
            onChange={handleChange}
            required
          />

          <select
            name="course"
            value={formData.course}
            onChange={handleChange}
            required
          >
            <option value="">Select Course</option>
            <option value="Machine Learning">Machine Learning</option>
            <option value="Deep Learning">Deep Learning</option>
            <option value="Quantum Computing">Quantum Computing</option>
          </select>

          <input
            name="email"
            type="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
            required
          />

          <input
            name="mobile"
            type="tel"
            placeholder="Mobile Number (optional)"
            value={formData.mobile}
            onChange={handleChange}
          />

          <input
            name="amount"
            type="number"
            placeholder="Amount (₹)"
            value={formData.amount}
            readOnly
          />
          {/* Important Payment Notice */}
          <div className="payment-important-note">
            <p><strong>Important Notice:</strong></p>

            <p>
              The internship registration fee is
              <span className="highlight-text"> non-refundable under any circumstances.</span>
            </p>

            <p>
              Stipend-based internship opportunities will be offered only to
              candidates who secure the highest score in the training assessment.
            </p>

            <p className="mandatory-line">
              ⚠ Clearing the interview is mandatory to secure a stipend internship.
            </p>
          </div>
          <button type="submit" disabled={isLoading || !acceptedTerms}>
            {isLoading ? "Processing..." : "Proceed to Pay"}
          </button>

          {/* Terms & Conditions Section */}
          <div className="terms-container">
            <label className="terms-label">
              <input
                type="checkbox"
                checked={acceptedTerms}
                onChange={(e) => setAcceptedTerms(e.target.checked)}
              />
              I agree to the Terms & Conditions and Refund Policy
            </label>

            <div className="terms-text">
              <p>• Internship fee is non-refundable once payment is completed.</p>
              <p>• Ensure all personal and course details are correct before proceeding.</p>
              <p>• Payment confirms your internship registration.</p>
              <p>• For payment issues, contact support within 24 hours.</p>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PayIntern;
